<template>
    <b-form-group :label="label" label-for="sections">
        <multiselect
            id="sections"
            :state="state"
            :selected="value"
            :options="sectionsOptions"
            :disabled="disabled"
            :loading="sectionsAreLoading"
            @click="getSections()"
            @changeValue="onChangeValue"
        >
            <template slot="c-option" slot-scope="{ options: { option } }">
                <span
                    v-if="option.type === 'unit'"
                    :style="{ marginLeft: `${option.depth * 12}px` }"
                >
                    <i class="fa fa-industry mr-1" />
                    {{ option.label }}
                </span>
                <span
                    v-if="option.type === 'department'"
                    :style="{ marginLeft: `${option.depth * 12}px` }"
                >
                    <i class="fa fa-users mr-1" />
                    {{ option.label }}
                </span>
            </template>
        </multiselect>
    </b-form-group>
</template>

<script>
import api from '@/services/api'
import { Multiselect } from '@/views/components/selects'

export default {
    name: 'Sections',
    components: {
        Multiselect,
    },
    props: {
        value: {
            type: Array,
            required: true,
        },
        state: {
            type: Boolean,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        loadDataWhenMounted: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            sectionsOptions: [],
            sectionsAreLoading: false,
            sectionsAlreadyLoaded: false,
        }
    },
    mounted() {
        if (this.loadDataWhenMounted) {
            this.getSections()
        }
    },
    methods: {
        onChangeValue(event) {
            this.$emit('update:value', event)
            this.$emit('change')
        },
        getSections() {
            if (!this.sectionsAlreadyLoaded) {
                this.sectionsAreLoading = true
                api.get('/sections', {
                    params: {
                        sortedBy: 'desc',
                        orderBy: 'end_date',
                        searchFields: 'type:in',
                        search: 'type:department,unit',
                    },
                })
                    .then(resp => {
                        const {
                            data: { data },
                        } = resp
                        this.sectionsOptions = data.map(option => {
                            const { id, name, type, depth } = option
                            return {
                                value: id,
                                label: name,
                                type,
                                depth,
                            }
                        })

                        this.$emit('loaded', true)
                        this.$emit('options-loaded', this.sectionsOptions)
                    })
                    .catch(e => {
                        console.log(e)
                    })
                    .finally(() => {
                        this.sectionsAreLoading = false
                        this.sectionsAlreadyLoaded = true
                    })
            }
        },
    },
}
</script>

<style lang="scss" scope>
@import '@/scss/CustomMultiselect.scss';

.c-th:hover {
    cursor: pointer;
}
</style>
